import './report-featured-card.scss'

import _ from 'lodash'
import { take } from 'rxjs/operators'
import { Watch } from 'vue-property-decorator'
import { faExclamationTriangle, faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons'

import { SearchFeatured, getTranslatedString, ReportFeatured } from '@skinsoft/types'
import { itemSelectors } from '@skinsoft/selectors'
import { ItemDataStore } from '@skinsoft/entity'
import { ConditionReportPDFTransferHelper } from '@skinsoft/media-transfer-helper'
import { ReactiveVue } from '@skinsoft/reactive-vue'
import { ActionType, States, TitleClickAction, Touchable } from '@skinsoft/ui'
import Component from 'vue-class-component'
import { Media } from '../item-card/media'
import { DISPLAY_ALERT_TOPIC } from '@skinsoft/bus/src/busTopics'

@Component({
    components: {
        sMedia: Media,
        sTouchable: Touchable,
    },
    props: ['reportFeatured', 'targetRouteName', 'titleClickAction'],
    template: require('./report-featured-card.html')
})
export class ReportfeaturedCard extends ReactiveVue {

    public reportFeatured: ReportFeatured;
    public targetRouteName: string;
    private titleClickAction: TitleClickAction

    private state: States = States.PENDING;
    private concernedItemSummary: string = "";

    private $itemDataStore: ItemDataStore;
    private $conditionReportPDFTransferHelper: ConditionReportPDFTransferHelper;

    public editIcon = faExternalLinkAlt

    // Icons
    private warningIcon = faExclamationTriangle;

    public isReady() {
        return this.state === States.READY;
    }

    private async openReportDocument() {
        const response = await this.$conditionReportPDFTransferHelper.downloadOriginalPDFFile(this.reportFeatured.firstMedia).toPromise()
        const fileName = `${this.reportFeatured.referenceNumber}.pdf`;
        // Notify dl success
        if (response) {
            this.download(fileName, response)
            this.emitOnBus(DISPLAY_ALERT_TOPIC, {
                message: this.$t('listReportScreen.closed.downloadSuccess', { docTitle: fileName }),
                variant: "success"
            })

        }
        // Notify dl failure 
        else {
            this.emitOnBus(DISPLAY_ALERT_TOPIC, {
                message: this.$t('listReportScreen.closed.downloadFailure'),
                variant: "danger"
            })
        }
    }

    /**
     * Launches the downloading of a file
     * @param fileName 
     * @param text 
     */
    private download(fileName, text: string) {

        const data = window.URL.createObjectURL(text)
        const element = document.createElement('a')
        element.style.display = 'none'
        element.href = data;
        element.setAttribute('download', fileName)
        document.body.appendChild(element)
        element.click()
        document.body.removeChild(element)

        setTimeout(() => {
            window.URL.revokeObjectURL(data);
        }, 100);

    }

    private editReport() {
        if(this.titleClickAction && this.titleClickAction.action === ActionType.EDIT){
            // delay to let button animation occure
            setTimeout(() => {
                this.$router.push(
                    {
                        name: this.titleClickAction.targetRouteName,
                        params: {
                            reportId: this.reportFeatured.id
                        },
                    });
            }, 300);
        }
    }

    private onTitleClicked() {
        this.editReport()
    }

    private buildConcernedItemSummary() {
        const itemId = this.reportFeatured.involvedItem;
        if (itemId) {
            this.subscribeTo(this.$itemDataStore.fetchOne(itemId).pipe(take(1)),
                (item) => {
                    this.concernedItemSummary = itemSelectors.identifier(item, this.getAppLocale());
                    const itemTitle = itemSelectors.title(item, this.getAppLocale()) as string;
                    if (itemTitle) {
                        this.concernedItemSummary += `(${itemTitle})` as string;
                    }
                },
                'concerned-item'
            )
        }
    }

    private get reportReason(): string {
        return getTranslatedString(_.get(this.reportFeatured.reportReason, 'secondaryValue'), this.getAppLocale())
    }

    @Watch('reportFeatured', { immediate: true, deep: true })
    private onReportFeaturedChange(reportFeatured: SearchFeatured) {
        this.unsubscribeFrom('concerned-item');
        this.state = reportFeatured ? States.READY : States.PENDING;
        if (reportFeatured) {
            this.buildConcernedItemSummary();
        }
    }
}